import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for the SubPassages Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = [ 'subPassageGroup' ]
  connect () {
    super.connect()
    // add your code here, if applicable
  }

  add(e) {
    console.log('TODO ---> addSubPassage')
    const index = this.subPassageGroupTarget.children.length
    const newEl = document.createElement('div')
    newEl.setAttribute('id', `passage-${e.currentTarget.dataset.passageSlug}-sub-passage-${index}`)
    this.subPassageGroupTarget.appendChild(newEl, this.subPassageGroupTarget.firstChild)
    this.stimulate('SubPassages#add', newEl.id)
  }

  saveSubPassageText(e) {
    const elId = e.target.getAttribute('input')
    const input = document.getElementById(elId)
    // console.log(input)
    this.stimulate('SubPassages#auto_save_passage_text', e.target, input.value)
  }

  remove(e) {
    if (confirm('Are you sure you want to delete this source?')) {
      this.stimulate('SubPassages#remove', e.target)
    }
  }
}
